import {Chip} from "@progress/kendo-react-buttons"
import {DropDownList, ListItemProps} from "@progress/kendo-react-dropdowns"
import {FieldRenderProps} from "@progress/kendo-react-form"
import React from "react"
import {UserDealer} from "../../../containers/App/models"

const BKDropdownField = (fieldRenderProps: FieldRenderProps) => {
    const {name, label, data, stateValue, textField, dataItemKey, loading, onChange, disabled} = fieldRenderProps

    const dealerItemRender = (li: React.ReactElement<HTMLLIElement>, itemProps: ListItemProps) => {
        const item = itemProps.dataItem as UserDealer
        const itemChildren = (
            <div key={`data_item_${item.dealerId}`} className="d-flex w-100">
                <div className="me-auto">{li.props.children}</div>
                {item.hasLocalATF && (
                    <Chip size={"small"}>
                        <span className="small">ATF</span>
                    </Chip>
                )}
            </div>
        )
        return React.cloneElement(li, li.props, itemChildren)
    }

    const dealerValueRender = (element: React.ReactElement<HTMLSpanElement>, value: any) => {
        if (!value) {
            return element
        }

        const val = value as UserDealer

        const children = [
            <div className="d-flex w-100">
                <div className="me-auto">{element.props.children}</div>
                {val.hasLocalATF && (
                    <Chip size={"small"}>
                        <span className="small">ATF</span>
                    </Chip>
                )}
            </div>,
        ]

        return React.cloneElement(element, {...element.props}, children)
    }

    return (
        <>
            <DropDownList
                name={name}
                label={label}
                data={data}
                value={data.find((t: {[x: string]: any}) => t[`${dataItemKey}`] === stateValue)}
                textField={textField}
                dataItemKey={dataItemKey}
                loading={loading}
                onChange={onChange}
                itemRender={name === "dealerID" ? dealerItemRender : undefined}
                valueRender={name === "dealerID" ? dealerValueRender : undefined}
                disabled={disabled}
            />
        </>
    )
}

export default BKDropdownField
